import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, NgModule, Provider } from '@angular/core';
import { FreelancerAsyncPipe } from './async.pipe';

@NgModule({
  declarations: [FreelancerAsyncPipe],
  exports: [FreelancerAsyncPipe],
  providers: [AsyncPipe, ChangeDetectorRef as Provider, FreelancerAsyncPipe],
})
export class FreelancerAsyncPipeModule {}
